import { useEffect, useState } from 'react';
import { VersionedSnippet, AssetUrlProps } from '@cld/code-snippet-next';
import { fetchParsedSnippets, FetchSnippets } from '../api/fetchParsedSnippets';
import { FetchSnippetProps } from '../serverTypes';

// TODO: as breaking change, move fetchSnippets to first argument (avoid bastard injection [default implementation] and allow to curry dependencies)
export const useFetchCodeSnippets = (options: FetchSnippetProps, fetchSnippets: FetchSnippets = fetchParsedSnippets) => {
  const { url } = options;
  const [snippets, setSnippets] = useState<VersionedSnippet[]>();
  const [parsedUrl, setParsedUrl] = useState<AssetUrlProps>();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    let isCancelled = false;

    const fetchData = async () => {
      try {
        const data = await fetchSnippets(options);
        // istanbul ignore else
        if (!isCancelled) {
          setSnippets(data.parsedSnippets);
          setParsedUrl(data.parsedUrl);
          setIsLoading(false);
        }
      } catch (error) {
        console.error(error);
        setIsError(true);
      }
    };

    void fetchData();

    return () => {
      isCancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, fetchSnippets]);

  return { snippets, isLoading, isError, parsedUrl };
};
